// Rotating accent colors per card so the row reads with some visual
// variety instead of one repeated tone — cycles through the brand's
// blue/green/gold/marigold palette. Content per client's "WHY CHOOSE
// US" list; "Affordable Pricing" from that list is intentionally
// reworded to "Clear, Personalized Pricing" since the client also
// asked to stop displaying rate cards site-wide — pricing is now
// discussed on the consultation call, not advertised as a number, so
// "Affordable Pricing" as a bullet would be an unsupported claim to
// show next to a site with no visible prices at all.
const REASONS = [
  { title: 'PAN India Services', desc: 'Registrations, filings, and compliance support for clients anywhere in India.', icon: '🇮🇳', bg: 'bg-seal-blue/10' },
  { title: '100% Online Process', desc: 'Every step — documents, payment, and status updates — handled online.', icon: '💻', bg: 'bg-marigold/15' },
  { title: 'Experienced Professionals', desc: 'Our team includes experienced tax and legal professionals across every service area.', icon: '🎓', bg: 'bg-ledger-green/10' },
  { title: 'Clear, Personalized Pricing', desc: 'No published rate card — we discuss your exact requirement on a call and quote transparently.', icon: '🧾', bg: 'bg-gold/15' },
  { title: 'Secure Document Handling', desc: 'Your documents are stored securely and only accessed by your assigned team.', icon: '🔒', bg: 'bg-seal-blue/10' },
  { title: 'Fast Processing', desc: 'Most registrations and filings are completed within days, not weeks.', icon: '⚡', bg: 'bg-marigold/15' },
  { title: 'Dedicated Relationship Manager', desc: 'A single point of contact who knows your case from start to finish.', icon: '🤝', bg: 'bg-ledger-green/10' },
  { title: 'Lifetime Support', desc: 'We stay reachable for follow-up questions even after your service is complete.', icon: '♾️', bg: 'bg-gold/15' },
];

export function WhyChooseUs() {
  return (
    <section className="border-t border-line bg-white py-16">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono text-xs uppercase tracking-widest text-ledger-green">Why Choose Us</p>
          <h2 className="mt-2 font-display text-3xl font-bold text-ink">Built on Trust, Backed by Process</h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {REASONS.map((reason) => (
            <div key={reason.title} className="text-center">
              <div className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full text-2xl ${reason.bg}`}>
                {reason.icon}
              </div>
              <h3 className="mt-4 font-display text-base font-semibold text-ink">{reason.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/60">{reason.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
